import React from 'react';

import { ReactComponent as FacebookIcon } from '/src/images/icons/facebook.svg';
import { ReactComponent as InstagramIcon } from '/src/images/icons/instagram.svg';
import { ReactComponent as LinkedInIcon } from '/src/images/icons/linkedin.svg';
import { ReactComponent as PinterestIcon } from '/src/images/icons/pinterest.svg';
import { ReactComponent as Snapchat } from '/src/images/icons/snapchat.svg';
import { ReactComponent as Telegram } from '/src/images/icons/telegram.svg';
import { ReactComponent as TiktokIcon } from '/src/images/icons/tiktok.svg';
import { ReactComponent as TripadvisorIcon } from '/src/images/icons/tripadvisor.svg';
import { ReactComponent as TwitterIcon } from '/src/images/icons/twitter.svg';
import { ReactComponent as VkontakteIcon } from '/src/images/icons/vkontakte.svg';
import { ReactComponent as WebsiteIcon } from '/src/images/icons/website.svg';
import { ReactComponent as WhatsApp } from '/src/images/icons/whatsapp.svg';
import { ReactComponent as YoutubeIcon } from '/src/images/icons/youtube.svg';

import { ILibrarySocialMediaLinks } from '../../queries/fragments/librarySocialMediaLinks';
import * as styles from './social-media-links-list.module.scss';

interface socialMediaLinksListProps {
  socialMediaLinks?: ILibrarySocialMediaLinks;
  cssClass?: string;
  itemCssClass?: string;
}
export const SocialMediaLinksList = ({
  socialMediaLinks,
  cssClass,
  itemCssClass,
}: socialMediaLinksListProps) => {
  return (
    <ul
      className={
        cssClass && cssClass.length > 0
          ? cssClass
          : 'flex flex-wrap justify-center md:justify-start'
      }
    >
      {socialMediaLinks?.webUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.webUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Website"
          >
            <WebsiteIcon />
          </a>
        </li>
      )}
      {socialMediaLinks?.snapchatUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.snapchatUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Snapchat"
          >
            <Snapchat />
          </a>
        </li>
      )}
      {socialMediaLinks?.telegramUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.telegramUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Telegram"
          >
            <Telegram />
          </a>
        </li>
      )}
      {socialMediaLinks?.whatsAppUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.whatsAppUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="WhatsApp"
          >
            <WhatsApp />
          </a>
        </li>
      )}
      {socialMediaLinks?.facebookUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.facebookUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Facebook"
          >
            <FacebookIcon />
          </a>
        </li>
      )}
      {socialMediaLinks?.twitterUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.twitterUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Twitter"
          >
            <TwitterIcon />
          </a>
        </li>
      )}
      {socialMediaLinks?.instagramUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.instagramUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Instagram"
          >
            <InstagramIcon />
          </a>
        </li>
      )}
      {socialMediaLinks?.youTubeUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.youTubeUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Youtube"
          >
            <YoutubeIcon />
          </a>
        </li>
      )}
      {socialMediaLinks?.tripadvisorUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.tripadvisorUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Tripadvisor"
          >
            <TripadvisorIcon />
          </a>
        </li>
      )}
      {socialMediaLinks?.tikTokUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.tikTokUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Tiktok"
          >
            <TiktokIcon />
          </a>
        </li>
      )}
      {socialMediaLinks?.vkontakteUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.vkontakteUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Vkontakte"
          >
            <VkontakteIcon />
          </a>
        </li>
      )}
      {socialMediaLinks?.linkedInUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.linkedInUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="LinkedIn"
          >
            <LinkedInIcon />
          </a>
        </li>
      )}
      {socialMediaLinks?.pinterestUrl && (
        <li
          className={
            itemCssClass && itemCssClass.length > 0
              ? itemCssClass
              : 'mx-2 mb-5 md:mr-5'
          }
        >
          <a
            href={socialMediaLinks.pinterestUrl}
            className={styles.social}
            target="_blank"
            rel="noreferrer"
            title="Pinterest"
          >
            <PinterestIcon />
          </a>
        </li>
      )}
    </ul>
  );
};
